import React, { useState, useEffect } from 'react';

function useTypewriter(texts, speed) {
  const [typed, setTyped] = useState("");
  const [currentTextIndex, setCurrentTextIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);

  useEffect(() => {
    if (charIndex < texts[currentTextIndex].length) {
      const timeoutId = setTimeout(() => {
        setTyped((prev) => prev + texts[currentTextIndex].charAt(charIndex));
        setCharIndex(charIndex + 1);
      }, speed);

      return () => clearTimeout(timeoutId);
    } else if (currentTextIndex < texts.length - 1) {
      const timeoutId = setTimeout(() => {
        setTyped("");
        setCharIndex(0);
        setCurrentTextIndex(currentTextIndex + 1);
      }, 2000); // 1秒後に次の文に移る

      return () => clearTimeout(timeoutId);
    }
  }, [texts, currentTextIndex, charIndex, speed]);

  const cursor = <span className="cursor">|</span>;
  return <><span>{typed}</span>{cursor}</>;
}

export default useTypewriter;
